<script setup lang="ts">
const cartStore = useCartStore();
const bannerTypeToShow = computed(() => cartStore.bannerTypeToShow);
const { promoCodeBanner } = storeToRefs(cartStore);

const isVisible = computed(() => promoCodeBanner.value?.showBanner && bannerTypeToShow.value === "minimum_amount");

</script>

<template>
  <div
    v-if="isVisible"
    class="tw-sticky tw-top-0 tw-right-0 tw-left-0 tw-z-50 promo-banner tw-bg-nl-green-100 tw-h-[45px] tw-text-nl-yellow-100 tw-font-agenda tw-flex tw-items-center tw-justify-center tw-uppercase tw-font-semibold tw-tracking-wide tw-text-center tw-leading-[1.04] tw-px-5"
  >
    ALMOST THERE! ADD MORE ITEMS TO ACTIVATE YOUR PROMO
  </div>
</template>

